import { io } from "socket.io-client";

const SOCKET_SERVER_URL = "https://rentay.net";

export const initializeSocket = (token) => {
    if (!token) {
        console.error("Socket connection failed: No token provided");
        return null;
    }


    const socket = io(SOCKET_SERVER_URL, {
        transports: ['websocket', 'polling'],
        pingInterval: 10000,
        pingTimeout: 30000,
        query: { token: token }
    });

    socket.on("connect", () => {
        console.log("Connected to socket server:", socket.id);
    });


    return socket;
};
